import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useBreakpointContext } from 'EmailEditorUI/components/mo/BreakpointContext';
import { getIsSingleColumnFullWidth, getLayoutPadding, getMobileLayoutPadding
// @ts-expect-error no declarations found for module
} from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
// @ts-expect-error no declarations found for module
import { generatePadding } from 'EmailEditorUI/utils/styleUtils';
import useIsLayoutPaddingDisabled from 'EmailEditorUI/hooks/styleSettings/useIsLayoutPaddingDisabled';
const SIDES = ['top', 'bottom'];
const EMPTY_PADDING = {
  value: 0,
  units: 'px'
};
function extractValues(padding) {
  return Object.entries(padding).reduce((acc, [key, side]) => {
    var _side$value;
    acc[key] = (_side$value = side === null || side === void 0 ? void 0 : side.value) !== null && _side$value !== void 0 ? _side$value : 0;
    return acc;
  }, {});
}
function useEffectiveLayoutPadding() {
  const {
    breakpointName
  } = useBreakpointContext();
  const layoutPadding = useSelector(getLayoutPadding);
  const mobileLayoutPadding = useSelector(getMobileLayoutPadding);
  const isSingleColumnFullWidth = useSelector(getIsSingleColumnFullWidth);
  const isTopDisabled = useIsLayoutPaddingDisabled('top');
  const isBottomDisabled = useIsLayoutPaddingDisabled('bottom');
  return useMemo(() => {
    var _layoutPadding$toJS, _mobileLayoutPadding$;
    if (isSingleColumnFullWidth) {
      return extractValues(generatePadding({
        top: 0,
        bottom: 0
      }));
    }
    const layoutPaddingJS = (_layoutPadding$toJS = layoutPadding === null || layoutPadding === void 0 ? void 0 : layoutPadding.toJS()) !== null && _layoutPadding$toJS !== void 0 ? _layoutPadding$toJS : {};
    const mobileLayoutPaddingJS = (_mobileLayoutPadding$ = mobileLayoutPadding === null || mobileLayoutPadding === void 0 ? void 0 : mobileLayoutPadding.toJS()) !== null && _mobileLayoutPadding$ !== void 0 ? _mobileLayoutPadding$ : {};
    const result = SIDES.reduce((acc, cur) => {
      if (cur === 'top' && isTopDisabled || cur === 'bottom' && isBottomDisabled) {
        acc[cur] = EMPTY_PADDING;
        return acc;
      }
      if (breakpointName === 'default') {
        acc[cur] = layoutPaddingJS[cur];
      } else {
        acc[cur] = mobileLayoutPaddingJS[cur] || layoutPaddingJS[cur];
      }
      return acc;
    }, {});
    return extractValues(result);
  }, [breakpointName, isBottomDisabled, isSingleColumnFullWidth, isTopDisabled, layoutPadding, mobileLayoutPadding]);
}
export default useEffectiveLayoutPadding;